import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../utils/baseQueryFn';

export const cashFlowApi = createApi({
  reducerPath: 'cashFlowApi',
  baseQuery,
  endpoints: (builder) => ({
    getCashFlow: builder.query({
      query: ({ page, limit, type, startDate, endDate, reason_ids }) => {
        const queryParams = new URLSearchParams({
          page,
          limit,
        });

        if (type) {
          queryParams.append('type', type);
        }
        if (startDate) {
          queryParams.append('start_date', startDate);
        }

        if (endDate) {
          queryParams.append('end_date', endDate);
        }
        if (reason_ids.length > 0) {
          queryParams.append('reason_ids', JSON.stringify(reason_ids));
        }
        const apiUrl = `main/v1/petty-cash-transactions?${queryParams.toString()}`;

        return {
          url: apiUrl,
          method: 'GET',
        };
      },
      transformResponse: (response) => response,
      providesTags: ['cashFlow'],
    }),
    getAllCashFlow: builder.mutation({
      query: ({ page, limit, type, startDate, endDate, reason_ids }) => {
        const queryParams = new URLSearchParams({
          page,
          limit,
        });

        if (type) {
          queryParams.append('type', type);
        }
        if (startDate) {
          queryParams.append('start_date', startDate);
        }

        if (endDate) {
          queryParams.append('end_date', endDate);
        }
        if (reason_ids.length > 0) {
          console.log(reason_ids)
          queryParams.append('reason_ids', JSON.stringify(reason_ids));
        }
        const apiUrl = `main/v1/petty-cash-transactions?${queryParams.toString()}`;

        return {
          url: apiUrl,
          method: 'GET',
        };
      },
      transformResponse: (response) => response,
      providesTags: ['cashFlow'],
    }),
    createCashFlow: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-transactions/new`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['cashFlow'],
    }),
    updateCashFlow: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-transactions/edit`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['cashFlow'],
    }),
    getCashFlowByID: builder.query({
      query: (id) => ({
        url: `main/v1/petty-cash-transactions/${id}`,
        method: 'GET',
      }),
      transformResponse: (response) => response,
      providesTags: ['cashFlow'],
    }),
    deleteCashFlow: builder.mutation({
      query: (body) => ({
        url: `main/v1/petty-cash-transactions/delete`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['cashFlow'],
    }),
  }),
});

export const {
  useGetCashFlowQuery,
  useCreateCashFlowMutation,
  useUpdateCashFlowMutation,
  useGetCashFlowByIDQuery,
  useGetAllCashFlowMutation,
  useDeleteCashFlowMutation
} = cashFlowApi;
